import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '../../../../core/form/ButtonGroup';

const ContentVisualizationToggle = (props) => (
  <ButtonGroup
    onChange={props.onChange}
    value={props.value}
    options={[
      {
        label: 'Global',
        value: 'chart',
      },
      {
        label: 'Per Course',
        value: 'list',
      },
    ]}
  />
);

ContentVisualizationToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default ContentVisualizationToggle;
